import { render, staticRenderFns } from "./DuplicateRfqModal.vue?vue&type=template&id=4c1c39d8"
import script from "./DuplicateRfqModal.vue?vue&type=script&lang=js"
export * from "./DuplicateRfqModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports